document.addEventListener("DOMContentLoaded", function() {

    var selected_variant = $('.hidden_selected_id');

  if(selected_variant){

    console.log(parseInt(selected_variant.attr('data_stck')));
      if(parseInt(selected_variant.attr('data_stck')) < 5 && parseInt(selected_variant.attr('data_stck')) > 0 && selected_variant.attr('data_inventory_policy') == 'deny'){
        
        $('.stock_indicator_block').show();
      }
      else if(parseInt(selected_variant.attr('data_stck')) == 0){
        $('.stock_indicator_block').hide();  
      }
      else{
        $('.stock_indicator_block').hide();
      }
    
    
  }
  
          
  
});
var sizeGuideTrigger = document.getElementById("custom-size-guide");
var sizeGuidePopup = document.getElementById("size-guide--popup");
var siteControlInner = document.getElementById("site-control");
var closeButton = document.getElementById("size_modal_close");
var outercloseButton = document.getElementById("size_modal_background");

sizeGuideTrigger.addEventListener("click", function () {
    sizeGuidePopup.style.display = "block";
    outercloseButton.style.display ="flex";
    document.body.style.overflow = "hidden";
    siteControlInner.classList.add("active");
});

closeButton.addEventListener("click", function () {
    sizeGuidePopup.style.display = "none";
 outercloseButton.style.display ="none";
    siteControlInner.classList.remove("active");
  document.body.style.overflow = "";
});
outercloseButton.addEventListener("click", function () {
    sizeGuidePopup.style.display = "none";
  outercloseButton.style.display ="none";
    siteControlInner.classList.remove("active");
  document.body.style.overflow = "";
})

